<template>
    <div class="wh100">
        <div class="breadcrumb-layout" v-if="orderId==null">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>订单操作记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="orders-list-container">
            <el-table :data="servcOrderRecordList" border style="width: 100%" class="mt30">
                <el-table-column prop="actorName" label="操作人" width="180" align="center"></el-table-column>
                <el-table-column prop="action" label="动作" width="180" align="center"></el-table-column>
                <el-table-column prop="actRole" label="操作人身份" width="260" align="center"></el-table-column>
                <el-table-column prop="extraInfo" label="附加信息" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="ts" label="操作时间" align="center" width="260"></el-table-column>
            </el-table>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" layout="total, sizes, prev, pager, next, jumper" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servcOrderApi from '../../api/servcOrder'

    export default {
        name: 'swb-servc-order-record-list',
        desc: '订单操作记录',
        props: ['orderId'],
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                servcOrderRecordList: [],
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getServcOrderRecordList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServcOrderRecordList();
            },
            getServcOrderRecordList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.orderId = self.orderId;
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                servcOrderApi.getServOrderRecordList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        self.servcOrderRecordList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderRecordList.vue